import { ColumnPreferencesServiceImplFactory } from "../../core/impl/columnPreferencesServiceImpl";

type IColumnPreferencesService = ReturnType<
  typeof ColumnPreferencesServiceImplFactory
>;

export type IColumnPreferencesController = ReturnType<
  typeof ColumnPreferencesControllerFactory
>;

export const ColumnPreferencesControllerFactory = ({
  columnPreferencesService,
}: {
  columnPreferencesService: IColumnPreferencesService;
}) => {
  const getColumnPreferences = async (viewKey: string) => {
    return await columnPreferencesService.getColumnPreferences(viewKey);
  };

  /** Save global selection from an explicit column list. Presets are untouched. */
  const saveColumnPreferences = async (
    viewKey: string,
    selectedColumns: string[]
  ) => {
    return await columnPreferencesService.saveColumnPreferences(
      viewKey,
      selectedColumns
    );
  };

  const createPreset = async (
    viewKey: string,
    name: string,
    selectedColumns: string[]
  ) => {
    return await columnPreferencesService.createPreset(
      viewKey,
      name,
      selectedColumns
    );
  };

  const updatePreset = async (
    viewKey: string,
    presetId: string,
    updates: { name?: string; selectedColumns?: string[] }
  ) => {
    return await columnPreferencesService.updatePreset(
      viewKey,
      presetId,
      updates
    );
  };

  const deletePreset = async (viewKey: string, presetId: string) => {
    return await columnPreferencesService.deletePreset(viewKey, presetId);
  };

  /**
   * Explicit apply: server copies the preset's columns into the global
   * selection and returns the refreshed preference payload (including
   * selected_columns and the full preset library).
   */
  const applyPreset = async (viewKey: string, presetId: string) => {
    return await columnPreferencesService.applyPreset(viewKey, presetId);
  };

  return {
    getColumnPreferences,
    saveColumnPreferences,
    createPreset,
    updatePreset,
    deletePreset,
    applyPreset,
  };
};
